import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import * as Aos from 'aos';

@Component({
  selector: 'app-rcs',
  templateUrl: './rcs.component.html',
  styleUrls: ['./rcs.component.scss']
})
export class RcsComponent implements OnInit {
  
  constructor(
    private titleService: Title,
  )
  {    }

  ngOnInit(){
    this.titleService.setTitle('RCS');

    setTimeout(() => {
      Aos.init();
    }, 500);       
      Aos.refresh();
  }
}
